import { Field, useFormikContext } from 'formik';
import React from 'react';
import { DatePickerUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const ProdNonProductiveWorkFields = () => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-2 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="date"
          name="date"
          component={DatePickerUI}
          value={values.date}
          fullWidth
          label={<FormLabelUI text="Dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.date} />}
          onChange={(date) => {
            setFieldValue('date', date).then(() => {
              validateField('date');
            });
          }}
          InputLabelProps={{ shrink: values.date !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="number"
          name="timeSpentInMin"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Ráfordított idő (perc)" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.timeSpentInMin} />}
          InputLabelProps={{ shrink: values.timeSpentInMin !== '' }}
        />
      </div>
      <div className="col-span-4">
        <Field
          type="text"
          name="description"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Leírás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.description} />}
          InputLabelProps={{ shrink: values.description !== '' }}
          multiline
          rows={3}
        />
      </div>
    </div>
  );
};

export default ProdNonProductiveWorkFields;
